<div *ngIf="isInEdit; else templateViewMode">
    <na-app-management [data]="_data.appInfoList" (onValidChanged)="onAppDataValidChange($event)"></na-app-management>
</div>
<ng-template #templateViewMode>
    <na-app-management-preview [data]="_data.appInfoList"></na-app-management-preview>
</ng-template>